module.exports = __webpack_public_path__ + "web-icons.c64923460d7063beff89.svg";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/fonts/web-icons/web-icons.svg?v=0.2.3
// module id = ../../../../../src/fonts/web-icons/web-icons.svg?v=0.2.3
// module chunks = styles